(function () {
  if (window.__mdsCartDrawerControllerBound) return;
  window.__mdsCartDrawerControllerBound = true;
  document.documentElement.setAttribute('data-mds-cart-drawer-controller', 'loading');

  var MDS_DUO_VARIANT_ID = 52860479045917;
  var MDS_FOIL_HEADS_VARIANT_ID = 52860478882077;
  var MDS_GIFT_PROPERTY = '_mds_duo_gift';
  var MDS_GIFT_VALUE = 'true';
  var promoSyncQueue = Promise.resolve(null);

  function localeRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function ajaxCartAddUrl() {
    return localeRoot() + 'cart/add.js';
  }

  function ajaxCartUpdateUrl() {
    return localeRoot() + 'cart/update.js';
  }

  function ajaxCartJsonUrl() {
    return localeRoot() + 'cart.js';
  }

  function cartUrl() {
    if (window.routes && window.routes.cart_url) return window.routes.cart_url;
    return localeRoot() + 'cart';
  }

  function nativeCartAddUrl() {
    if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url;
    return localeRoot() + 'cart/add';
  }

  function cartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function closeMobileNav() {
    if (window.mdsMobileNav && typeof window.mdsMobileNav.isOpen === 'function' && window.mdsMobileNav.isOpen()) {
      window.mdsMobileNav.close();
    }
  }

  function openDrawer(cart, source) {
    if (!cart) return;
    closeMobileNav();

    if (typeof cart.open === 'function') {
      cart.open(source);
      return;
    }

    cart.classList.add('animate', 'active');
    cart.removeAttribute('aria-hidden');
    document.body.classList.add('overflow-hidden');
  }

  function normalizedPath(url) {
    return new URL(url, window.location.href).pathname.replace(/\/+$/, '').replace(/\.js$/, '');
  }

  function isCartAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action');
    if (!action) return false;

    try {
      return normalizedPath(action) === normalizedPath(nativeCartAddUrl());
    } catch (error) {
      return false;
    }
  }

  function setSubmitting(form, submitter, submitting) {
    form.dataset.mdsSubmitting = submitting ? 'true' : 'false';
    if (!submitter) return;

    if (submitting) {
      submitter.dataset.mdsWasDisabled = submitter.disabled ? 'true' : 'false';
      submitter.disabled = true;
      submitter.setAttribute('aria-disabled', 'true');
      submitter.setAttribute('aria-busy', 'true');
      return;
    }

    if (submitter.dataset.mdsWasDisabled !== 'true') submitter.disabled = false;
    delete submitter.dataset.mdsWasDisabled;
    submitter.removeAttribute('aria-disabled');
    submitter.removeAttribute('aria-busy');
  }

  function itemFromForm(form) {
    var formData = new FormData(form);
    var variantId = formData.get('id');
    var quantity = parseInt(formData.get('quantity') || '1', 10);

    if (!variantId) throw new Error('Missing product variant.');
    if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;

    var item = {
      id: variantId,
      quantity: quantity
    };

    var sellingPlan = formData.get('selling_plan');
    if (sellingPlan) item.selling_plan = sellingPlan;

    var properties = {};
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (!match) return;
      properties[match[1]] = value;
    });

    if (Object.keys(properties).length) item.properties = properties;
    return item;
  }

  function requestedSections(cart) {
    if (cart && typeof cart.getSectionsToRender === 'function') {
      var ids = cart.getSectionsToRender().map(function (section) {
        return section.id;
      }).filter(Boolean);
      if (ids.length) return ids;
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function sectionsUrl() {
    return window.location.pathname + window.location.search;
  }

  function parseJsonResponse(response) {
    return response.text().then(function (text) {
      var payload;
      try {
        payload = JSON.parse(text);
      } catch (error) {
        error.mdsResponseOk = response.ok;
        throw error;
      }

      if (!response.ok || payload.status || payload.errors) {
        var message = payload.description || payload.message || payload.errors || 'Unable to update the cart.';
        if (typeof message !== 'string') message = JSON.stringify(message);
        var requestError = new Error(message);
        requestError.mdsResponseOk = false;
        throw requestError;
      }

      return payload;
    });
  }

  function cartJsonRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(parseJsonResponse);
  }

  function fetchCartState() {
    return fetch(ajaxCartJsonUrl(), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(parseJsonResponse);
  }

  function isPromoGiftLine(item) {
    if (!item || Number(item.variant_id) !== MDS_FOIL_HEADS_VARIANT_ID) return false;
    if (!item.properties) return false;
    return String(item.properties[MDS_GIFT_PROPERTY]) === MDS_GIFT_VALUE;
  }

  function notifyPromoCartUpdate(response) {
    document.dispatchEvent(new CustomEvent('mds:duo-gift-synced', { detail: response }));

    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'mds-duo-gift',
          cartData: response,
          variantId: MDS_FOIL_HEADS_VARIANT_ID
        });
      }
    } catch (error) {
      console.error('[Maison de Soin gift cart notification]', error);
    }
  }

  function performDuoGiftSync(initialResponse) {
    return fetchCartState().then(function (cartState) {
      var duoQuantity = 0;
      var manualHeadsQuantity = 0;
      var giftLines = [];

      (cartState.items || []).forEach(function (item) {
        if (Number(item.variant_id) === MDS_DUO_VARIANT_ID) {
          duoQuantity += Number(item.quantity) || 0;
        }

        if (Number(item.variant_id) !== MDS_FOIL_HEADS_VARIANT_ID) return;

        if (isPromoGiftLine(item)) {
          giftLines.push(item);
        } else {
          manualHeadsQuantity += Number(item.quantity) || 0;
        }
      });

      var desiredGiftQuantity = Math.max(duoQuantity - manualHeadsQuantity, 0);
      var currentGiftQuantity = giftLines.reduce(function (sum, item) {
        return sum + (Number(item.quantity) || 0);
      }, 0);

      if (desiredGiftQuantity === currentGiftQuantity && giftLines.length <= 1) {
        return { changed: false, response: initialResponse || null };
      }

      var sections = requestedSections(cartDrawer());
      var sectionParams = {
        sections: sections.join(','),
        sections_url: sectionsUrl()
      };

      if (!giftLines.length && desiredGiftQuantity > 0) {
        var properties = {};
        properties[MDS_GIFT_PROPERTY] = MDS_GIFT_VALUE;

        return cartJsonRequest(ajaxCartAddUrl(), {
          items: [
            {
              id: MDS_FOIL_HEADS_VARIANT_ID,
              quantity: desiredGiftQuantity,
              properties: properties
            }
          ],
          sections: sectionParams.sections,
          sections_url: sectionParams.sections_url
        }).then(function (response) {
          notifyPromoCartUpdate(response);
          return { changed: true, response: response };
        });
      }

      var updates = {};
      giftLines.forEach(function (item, index) {
        updates[item.key] = index === 0 ? desiredGiftQuantity : 0;
      });

      return cartJsonRequest(ajaxCartUpdateUrl(), {
        updates: updates,
        sections: sectionParams.sections,
        sections_url: sectionParams.sections_url
      }).then(function (response) {
        notifyPromoCartUpdate(response);
        return { changed: true, response: response };
      });
    });
  }

  function syncDuoGift(initialResponse) {
    var run = function () {
      return performDuoGiftSync(initialResponse);
    };
    promoSyncQueue = promoSyncQueue.then(run, run);
    return promoSyncQueue;
  }

  function renderDrawer(cart, response, source) {
    if (!cart) return false;
    if (!response || !response.sections || !response.sections['cart-drawer']) return false;

    if (typeof cart.renderContents === 'function') {
      try {
        cart.renderContents(response);
        window.setTimeout(function () {
          openDrawer(cart, source);
        }, 30);
        return true;
      } catch (error) {
        console.error('[Maison de Soin cart render]', error);
      }
    }

    try {
      var drawerDocument = new DOMParser().parseFromString(response.sections['cart-drawer'], 'text/html');
      var freshDrawer = drawerDocument.querySelector('#CartDrawer');
      var currentDrawer = document.querySelector('#CartDrawer');
      if (!freshDrawer || !currentDrawer) return false;
      currentDrawer.innerHTML = freshDrawer.innerHTML;

      if (response.sections['cart-icon-bubble']) {
        var iconDocument = new DOMParser().parseFromString(response.sections['cart-icon-bubble'], 'text/html');
        var freshIcon = iconDocument.querySelector('#cart-icon-bubble');
        var currentIcon = document.querySelector('#cart-icon-bubble');
        if (freshIcon && currentIcon) currentIcon.innerHTML = freshIcon.innerHTML;
      }

      if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      openDrawer(cart, source);
      return true;
    } catch (error) {
      console.error('[Maison de Soin cart fallback render]', error);
      return false;
    }
  }

  function submitNatively(form, submitter, error) {
    console.error('[Maison de Soin cart]', error);
    document.dispatchEvent(new CustomEvent('mds:cart-error', { detail: error }));
    setSubmitting(form, submitter, false);

    try {
      HTMLFormElement.prototype.submit.call(form);
    } catch (submitError) {
      console.error('[Maison de Soin native cart fallback]', submitError);
      window.location.assign(cartUrl());
    }
  }

  function addFormToDrawer(form, submitter) {
    if (!isCartAddForm(form) || form.dataset.mdsSubmitting === 'true') return;

    var item;
    try {
      item = itemFromForm(form);
    } catch (error) {
      submitNatively(form, submitter, error);
      return;
    }

    setSubmitting(form, submitter, true);

    var cart = cartDrawer();
    var sections = requestedSections(cart);
    var requestBody = {
      items: [item],
      sections: sections.join(','),
      sections_url: sectionsUrl()
    };

    cartJsonRequest(ajaxCartAddUrl(), requestBody)
      .then(function (response) {
        return syncDuoGift(response)
          .then(function (syncResult) {
            return syncResult && syncResult.response ? syncResult.response : response;
          })
          .catch(function (error) {
            console.error('[Maison de Soin Duo gift sync]', error);
            document.dispatchEvent(new CustomEvent('mds:duo-gift-error', { detail: error }));
            return response;
          });
      })
      .then(function (response) {
        var rendered = renderDrawer(cart, response, submitter);
        document.dispatchEvent(new CustomEvent('mds:cart-added', { detail: response }));
        if (!rendered) window.location.assign(cartUrl());
      })
      .catch(function (error) {
        if (error && error.mdsResponseOk === true) {
          console.error('[Maison de Soin cart response]', error);
          window.location.assign(cartUrl());
          return;
        }
        submitNatively(form, submitter, error);
      })
      .finally(function () {
        if (document.documentElement.contains(form)) setSubmitting(form, submitter, false);
      });
  }

  function bindPromoCartUpdates() {
    if (window.__mdsDuoGiftPubSubBound) return;

    try {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) {
        return;
      }

      window.__mdsDuoGiftPubSubBound = true;
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'mds-duo-gift') return;
        syncDuoGift(null).catch(function (error) {
          console.error('[Maison de Soin Duo gift cart update]', error);
        });
      });

      syncDuoGift(null).catch(function (error) {
        console.error('[Maison de Soin Duo gift initial sync]', error);
      });
    } catch (error) {
      console.error('[Maison de Soin Duo gift binding]', error);
    }
  }

  window.addEventListener(
    'click',
    function (event) {
      if (!event.target || typeof event.target.closest !== 'function') return;

      var cartLink = event.target.closest('#cart-icon-bubble');
      if (cartLink) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openDrawer(cartDrawer(), cartLink);
        return;
      }

      var stickySubmitter = event.target.closest('#mds-sch-cta');
      if (stickySubmitter) {
        var stickyFormId = stickySubmitter.getAttribute('data-product-form-id') || stickySubmitter.getAttribute('form');
        var stickyForm = stickyFormId ? document.getElementById(stickyFormId) : null;
        if (!stickyForm) stickyForm = document.querySelector('.mds-fp__bundles-form');
        if (!isCartAddForm(stickyForm)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        addFormToDrawer(stickyForm, stickySubmitter);
        return;
      }

      var submitter = event.target.closest('button, input[type="submit"]');
      if (!submitter || submitter.type !== 'submit') return;

      var form = submitter.form || submitter.closest('form');
      if (!isCartAddForm(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      addFormToDrawer(form, submitter);
    },
    true
  );

  window.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!isCartAddForm(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      addFormToDrawer(
        form,
        event.submitter || form.querySelector('button[type="submit"], button:not([type]), input[type="submit"]')
      );
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindPromoCartUpdates, { once: true });
  } else {
    window.setTimeout(bindPromoCartUpdates, 0);
  }
  window.addEventListener('load', bindPromoCartUpdates, { once: true });

  window.mdsCartDrawerAdd = addFormToDrawer;
  window.mdsSyncDuoGift = syncDuoGift;
  document.documentElement.setAttribute('data-mds-cart-drawer-controller', 'ready');
})();